import { request } from "../";
export function getClients(params = {}) {
  return request({ url: "clients/", params });
}
export function createClient(data = {}) {
  return request({ url: "clients/", method: "POST", data });
}
export function getClient(id) {
  return request({ url: `clients/${id}/` });
}
export function updateClient(id, data) {
  return request({ url: `clients/${id}/`, data, method: "PUT" });
}



// WEBPACK FOOTER //
// ./src/api/clients/index.js